import React from "react";
import StoreDeliveryChargesInfo from "./StoreDeliveryChargesInfo";
import StoreFreePanelSampleBanner from "./StoreFreePanelSampleBanner";
import StoreQuoteDrawingAssistanceBanner from "./StoreQuoteDrawingAssistanceBanner";
import StoreSampleCabinetCta from "./StoreSampleCabinetCta";
import { CATALOG_PROMO_TOP_BANNER_INDEX } from "../catalogPromoBanners";

export default function StoreCatalogPromoBanner({
  bannerIndex,
  className = "px-3 mt-2",
  isLoggedIn = false,
  onAuthRequired,
  sampleCabinetVisible = false,
  sampleCabinetProject = null,
  sampleCabinetIsLoggedIn = false,
  onSampleCabinetAuthRequired,
  onSampleCabinetQuoteCreated,
  onSampleCabinetError,
  hidden = false,
}) {
  if (hidden) return null;

  if (bannerIndex === CATALOG_PROMO_TOP_BANNER_INDEX) {
    return (
      <StoreSampleCabinetCta
        className={className}
        visible={sampleCabinetVisible}
        sampleProject={sampleCabinetProject}
        isLoggedIn={sampleCabinetIsLoggedIn}
        onAuthRequired={onSampleCabinetAuthRequired}
        onQuoteCreated={onSampleCabinetQuoteCreated}
        onError={onSampleCabinetError}
      />
    );
  }
  if (bannerIndex === 1) {
    return <StoreDeliveryChargesInfo className={className} />;
  }
  if (bannerIndex === 2) {
    return (
      <StoreFreePanelSampleBanner
        className={className}
        isLoggedIn={isLoggedIn}
        onAuthRequired={onAuthRequired}
      />
    );
  }
  if (bannerIndex === 3) {
    return (
      <StoreQuoteDrawingAssistanceBanner
        className={className}
        isLoggedIn={isLoggedIn}
        onAuthRequired={onAuthRequired}
      />
    );
  }
  return null;
}
